/**
 * Sprint 0 placeholder. Each one names the sprint that replaces it, so an
 * unfinished screen is never mistaken for a broken one.
 */

interface PlaceholderProps {
  title: string;
  sprint: string;
}

export function Placeholder({ title, sprint }: PlaceholderProps) {
  return (
    <section>
      <h1>{title}</h1>
      <p style={{ color: 'var(--pp-ink-muted)', marginTop: 'var(--pp-space-3)' }}>
        Bu ekran henüz yapılmadı — {sprint}.
      </p>
    </section>
  );
}
